module.exports = __webpack_public_path__ + "static/media/default_platform.b6aadf5b.svg";